import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const user = await login(username, password);
      if (!user) {
        setError('Erreur lors de la connexion: utilisateur non reçu');
        return;
      }
      if (user.role === 'admin' || user.role === 'super_admin') {
        navigate('/dashboard');
      } else if (user.role === 'hotesse') {
        navigate('/hostess');
      } else {
        navigate('/home');
      }
    } catch (err) {
      setError(err.message || 'Erreur lors de la connexion');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(180deg, #bf0a30 0%, #dc143c 40%, #ff6b6b 60%, #ffffff 100%)',
      padding: '20px',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Stars decoration */}
      <div style={{ position: 'absolute', top: '80px', left: '30px', fontSize: '40px', color: '#ffffff', opacity: '0.9' }}>★</div>
      <div style={{ position: 'absolute', top: '130px', left: '80px', fontSize: '25px', color: '#ffffff', opacity: '0.7' }}>★</div>
      <div style={{ position: 'absolute', top: '100px', right: '50px', fontSize: '35px', color: '#ffffff', opacity: '0.8' }}>★</div>
      <div style={{ position: 'absolute', top: '150px', right: '100px', fontSize: '20px', color: '#ffffff', opacity: '0.6' }}>★</div>

      {/* Cola wave decoration */}
      <div style={{
        position: 'absolute',
        bottom: '0',
        left: '0',
        right: '0',
        height: '8px',
        background: 'linear-gradient(90deg, #1a1a1a 0%, #3d1c0f 25%, #5c2e0e 50%, #3d1c0f 75%, #1a1a1a 100%)'
      }}></div>

      <div style={{
        maxWidth: '450px',
        width: '100%',
        background: '#ffffff',
        borderRadius: '20px',
        padding: '40px',
        boxShadow: '0 25px 70px rgba(0, 0, 0, 0.5)',
        border: '5px solid #1a1a1a',
        position: 'relative',
        zIndex: '1'
      }}>
        {/* Stars on card */}
        <div style={{ position: 'absolute', top: '10px', left: '50%', transform: 'translateX(-50%)', display: 'flex', gap: '12px' }}>
          <span style={{ fontSize: '32px', color: '#bf0a30' }}>★</span>
          <span style={{ fontSize: '32px', color: '#3d1c0f' }}>★</span>
          <span style={{ fontSize: '32px', color: '#bf0a30' }}>★</span>
        </div>

        {/* Cola stripe */}
        <div style={{
          position: 'absolute',
          top: '0',
          left: '0',
          right: '0',
          height: '6px',
          background: 'linear-gradient(90deg, #1a1a1a 0%, #3d1c0f 50%, #bf0a30 100%)',
          borderRadius: '15px 15px 0 0'
        }}></div>

        {/* American Cola Logo */}
        <div style={{ textAlign: 'center', marginBottom: '30px', marginTop: '15px' }}>
          <img
            src="/logo.png"
            alt="American Cola"
            style={{
              width: '180px',
              height: 'auto',
              marginBottom: '15px',
              filter: 'drop-shadow(0 6px 20px rgba(61, 28, 15, 0.5))'
            }}
          />
          <h3 style={{
            color: '#1a1a1a',
            fontWeight: 'bold',
            margin: '10px 0 5px',
            fontSize: '28px',
            textTransform: 'uppercase',
            letterSpacing: '2px',
            whiteSpace: 'nowrap'
          }}>
            CARTE À GRATTER
          </h3>
        </div>

        {error && (
          <div className="alert alert-danger mb-3" role="alert" style={{
            background: '#ffe5e5',
            border: '2px solid #bf0a30',
            color: '#8b0000',
            borderRadius: '10px'
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label" style={{
              color: '#1a1a1a',
              fontWeight: 'bold',
              textTransform: 'uppercase',
              fontSize: '12px',
              letterSpacing: '1px'
            }}>
              Nom d'utilisateur
            </label>
            <input
              type="text"
              className="form-control"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoFocus
              style={{
                borderRadius: '10px',
                padding: '12px',
                border: '2px solid #3d1c0f',
                fontSize: '16px',
                background: '#fffaf0'
              }}
            />
          </div>
          <div className="mb-4">
            <label className="form-label" style={{
              color: '#1a1a1a',
              fontWeight: 'bold',
              textTransform: 'uppercase',
              fontSize: '12px',
              letterSpacing: '1px'
            }}>
              Mot de passe
            </label>
            <input
              type="password"
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{
                borderRadius: '10px',
                padding: '12px',
                border: '2px solid #3d1c0f',
                fontSize: '16px',
                background: '#fffaf0'
              }}
            />
          </div>
          <button
            type="submit"
            className="btn btn-primary w-100"
            disabled={loading}
            style={{
              background: 'linear-gradient(180deg, #bf0a30 0%, #8b0000 50%, #3d1c0f 100%)',
              border: '3px solid #1a1a1a',
              borderRadius: '15px',
              padding: '15px',
              fontSize: '18px',
              fontWeight: 'bold',
              textTransform: 'uppercase',
              letterSpacing: '2px',
              color: '#ffffff',
              boxShadow: '0 8px 25px rgba(0, 0, 0, 0.4)'
            }}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2"></span>
                Connexion...
              </>
            ) : 'Se connecter'}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: '25px', display: 'flex', justifyContent: 'center', gap: '10px' }}>
          <span style={{ fontSize: '20px', color: '#bf0a30' }}>★</span>
          <small style={{ color: '#3d1c0f', fontWeight: 'bold', fontSize: '12px' }}>
            © 2026 AMERICAN COLA.
          </small>
          <span style={{ fontSize: '20px', color: '#bf0a30' }}>★</span>
        </div>
      </div>
    </div>
  );
};

export default Login;
